export default __webpack_public_path__ + "static/media/angle-double-right-solid.669ffbe1.svg";